import type { RepositoryHttp } from "@/infrastructure/repositories/http";
import type { IRoutes } from "@/types/src/backend/routes";
export type JobHistoryFilteredParams =
  IRoutes.Endpoints.Expert.Jobs.Filter.GetJobHistoryFiltered["params"] &
    IRoutes.Endpoints.Expert.Jobs.Filter.GetJobHistoryFiltered["body"];

export class UseCasePostJobHistoryFiltered {
  constructor(private readonly repository: RepositoryHttp) {}

  public run = async (
    body?: IRoutes.Endpoints.Expert.Jobs.Filter.GetJobHistoryFiltered["body"],
    params?: IRoutes.Endpoints.Expert.Jobs.Filter.GetJobHistoryFiltered["params"],
  ) => {
    const url: IRoutes.Endpoints.Expert.Jobs.Filter.GetJobHistoryFiltered["url"] =
      "/expert/job/filter";

    type Output =
      IRoutes.Endpoints.Expert.Jobs.Filter.GetJobHistoryFiltered["outputData"];

    const data = {
      ...body,
      ...params,
    };

    const result = await this.repository.findByFilter<
      Output,
      JobHistoryFilteredParams
    >(String(url), data);

    return result;
  };
}
